import { ActionDto } from "../dto/Action.dto";
import { Action } from "../../entity/Action";
import { toDate } from "../../utils/GlobalFunctions";

export const mapActionDtoToAction = (actionDto: ActionDto[]): Action[] => {
  return actionDto.map((action) => {
    return {
      id: action.id,
      createdAt: toDate(action.createdAt),
      action: action.action,
      description: action.description,
      updatedAt: toDate(action.updatedAt),
    };
  });
};
